import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import TextField from 'material-ui/TextField'
import Divider from 'material-ui/Divider'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import StatusSelect from './StatusSelect'
import ExternalLinks from 'components/ExternalLinks'
import Events from './events'
import PropertyAvatar from './PropertyAvatar'
import ReportButton from '../ReportButton'

import dataActions from 'actions/dataActions'
import financeActions from 'actions/financeActions'

import { doc, dirtyRead } from 'selectors/common'
import Communication from 'components/Communication'

let select = dirtyRead(
	(state, props) => ({
		property: doc(state, props.propertyID)
	})
)

export class LeftSide extends Component{
	state = {
	   value: 1,
	 };

 	handleChange = (event, index, value) => this.setState({value});
	render(){
		let { props } = this
		if (!props.property) return null
		let address = props.property.address || ""
		return(
			<div
				key={props.property.alias}
				className="left-side"
				style={{
					 width: (this.props.colspan>1)?"50%":"100%"
   				   , overflowY: "auto"
				   , overflowX: "hidden"
					 , position: "relative"
					 , marginTop: "0"
				}}
			>
				<Communication objectID={"all"} path={this.props.path} />
			</div>
		)
	}
}

export default connect(select, {...dataActions, ...financeActions})(LeftSide)



// WEBPACK FOOTER //
// ./src/routes/landlord/dashboard/propertyForm/LeftSideCommunication.js